export default "__VITE_ASSET__DvB8qZoL__"